import React, {ButtonHTMLAttributes, DetailedHTMLProps, HTMLAttributeAnchorTarget, MouseEventHandler} from "react";
import {IonRouterLink} from "@ionic/react";
import {getManager} from "../../../ts/manager/Manager";
import {dispatchRedirectTo} from "../../../ts/event/DispatchEvent";

export interface IButtonAppProps
{
    href?: string;
    selected?: boolean;
    label?: string;
    loading?: boolean;
    nonButton?: boolean;
    target?: HTMLAttributeAnchorTarget;
    onClick?: () => void;
    onRedirectCallback?: () => void;
    className?:string
    conditionalClassName?:() => string
}

const AppButton = (props: IButtonAppProps & DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>) =>
{
    let {
        href,
        selected,
        label,
        loading,
        target,
        onRedirectCallback,
        className,
        conditionalClassName,
        children,
        ...elementProps
    } = props;

    const isAnchor = !!href;
    const isInternalRoute = isAnchor && href.startsWith("/");
    let anySelected = !!selected;
    if(isInternalRoute && href === getManager().navigation.model.href){
        anySelected = true;
    }
    const anyDisabled = anySelected || elementProps.disabled;
    const nonButton = elementProps.nonButton;
    className = className ?? "";
    let classes = className.split(" ");
    let useRouterLink = isInternalRoute && !onRedirectCallback;


    if(anyDisabled && !classes.includes("disabled")){
        className += " disabled";
    }
    if(isAnchor && !classes.includes("anchor") && !classes.includes("btn")){
        className += " anchor";
    }

    if(anySelected && !classes.includes("selected")){
        className += " selected";
    }
    if(nonButton && !classes.includes("non-button")){
        className += " non-button";
    }
    if(classes.includes("btn")){
        className += " text-nowrap";
    } else if(useRouterLink){
        className += " ion-a";
    }
    if(conditionalClassName){
        const conditionalClassNameValue = conditionalClassName();
        if(conditionalClassNameValue){
            className += " "+conditionalClassNameValue;
        }
    }
    let onClick:MouseEventHandler<HTMLButtonElement|HTMLAnchorElement|HTMLIonRouterLinkElement>|undefined ;
    if(isInternalRoute && onRedirectCallback)
    {
        onClick = (event) => {
            if(elementProps.onClick){
                elementProps.onClick();
            }
            event.preventDefault();

            dispatchRedirectTo(href, false, false, () => {
                onRedirectCallback();
            })
            return false;
        }
    } else {
        onClick = elementProps.onClick;
    }

    const getChildren = () =>
    {
        return <>

            {loading &&
                <span className="spinner-border spinner-border-sm me-2"/>
            }
            {!!label &&
                <span className="button-label">
                    {label}
                </span>
            }
            {!!children &&
                <span>
                    {children}
                </span>
            }
        </>
    }

    const constructInternalRoute = () =>
    {

        return <IonRouterLink
            routerDirection="none"
            routerLink={href!}
            aria-disabled={anyDisabled}
            className={className}
            onClick={onClick}
        >
            {getChildren()}
        </IonRouterLink>
    }

    const constructAnchor = () =>
    {
        return <a
            className={className}
            href={href!}
            target={target}
            onClick={onClick}
        >
            {getChildren()}
        </a>
    }

    const constructNonButton = () =>
    {
        return <span
            className={className}
            onClick={onClick}
        >
            {getChildren()}
        </span>
    }

    const constructButton = () =>
    {
        return <button
            {...elementProps}
            className={className+" n-btn"}
            type={elementProps.type ?? "button"}
            disabled={anyDisabled}
            onClick={onClick}
        >
            {getChildren()}
        </button>
    }

    if (useRouterLink)
    {
        return constructInternalRoute();
    }
    if (isAnchor)
    {
        return constructAnchor();
    }
    if (nonButton)
    {
        return constructNonButton();
    }

    return constructButton();
}

export default AppButton;